import { useModal } from '@/components/modals/Modal';
import { useTranslation } from '@/hooks/useTranslation';
import { PlusIcon } from '@/components/icons';
import { CompanyFieldsFragment } from '@/graphql/generated';
import { InvitationModal } from './InvitationModal';
import { DeepPartial } from '@apollo/client/utilities';

export const InvitationModalButton = ({
  enterprise,
}: {
  enterprise: DeepPartial<CompanyFieldsFragment>;
}) => {
  const modal = useModal();
  const { t } = useTranslation();

  const openInvitationModal = () => {
    modal.openModal(<InvitationModal enterprise={enterprise} />, {
      title: t('project.users.invitationModal.title'),
      isFullscreen: false,
      displayTitleBar: true,
    });
  };

  return (
    <button
      className="primary small purple shrink-0"
      onClick={openInvitationModal}
    >
      <PlusIcon />
      <span>{t('project.users.invite.button')}</span>
    </button>
  );
};
